import { classes as htmlClasses } from 'html-classes';
import { Children, forwardRef, isValidElement } from 'react';

import styles from './GridView.module.scss';
import { GridViewProps } from './interfaces';

const GridView = forwardRef<HTMLDivElement, GridViewProps>(
  ({ children, className }, ref) => (
    <div ref={ref} className={htmlClasses([styles.root, className])}>
      {Children.map(children, (child, key) => {
        if (!isValidElement<{ classes?: { tileClassName?: string } }>(child)) {
          return null;
        }

        const { tileClassName } = child.props.classes ?? {};
        return (
          <div
            key={isValidElement(child) && child.key ? child.key : key}
            className={htmlClasses([styles.tile, tileClassName])}
          >
            {child}
          </div>
        );
      })}
    </div>
  ),
);

GridView.displayName = 'GridView';

export default GridView;
